@if (ProposalRequestFormGroup && disableInput !== undefined) {
  <form class="container-fluid p-0" [formGroup]="ProposalRequestFormGroup">
    <div class="row">
      <div class="col">
        <app-display-card>
          <div class="inner-panel rounded">
            <div class="form-group mb-0">
              <label class="form-label" requiredAsterisk for="qsb-bid-name">
                Bid name
              </label>
              <input
                id="qsb-bid-name"
                type="text"
                class="form-control"
                formControlName="name"
              />
            </div>
          </div>
        </app-display-card>
      </div>
    </div>

    @if (
      ProposalRequestFormGroup.controls['id'].value &&
      ProposalRequestFormGroup.controls['Site'].controls['id'].value
    ) {
      <div class="row mt-3">
        <div class="col">
          <app-display-card>
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h3 class="mb-0">Selected site</h3>
              <button
                type="button"
                class="btn btn-outline"
                (click)="showGrid = true"
              >
                Select new site
              </button>
            </div>
            <div class="inner-panel rounded">
              <div class="selected-site-name">
                {{
                  ProposalRequestFormGroup.controls['Site'].controls[
                    'legalName'
                  ].value
                }}
              </div>
            </div>
          </app-display-card>
        </div>
      </div>
    }

    @if (!ProposalRequestFormGroup.controls['id'].value || showGrid) {
      <div class="row mt-3 minvh-70">
        <div class="col">
          <app-sites-grid
            [gridName]="'ClientSites'"
            (rowSelectionChanged)="setSiteId($event)"
            [selectedRowsPrimaryKeys]="selectedRowsPrimaryKeys"
            [selectionEnabled]="!disableInput"
            [cellSelection]="false"
            [suppliedQueryData]="SuppliedSiteQueryData"
          ></app-sites-grid>
        </div>
      </div>
    }
  </form>
}
